var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quiz',{attrs:{"type":"session","send":_vm.send,"get":_vm.get,"redirect":_vm.successRedirect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }